import { Component } from "react";
import { FOOTER_COLUMNS, FOOTER_LEGAL_LINKS } from '../../commons/site-nav';
import styles from './footer-v2.component.module.scss';

/**
 * Site footer. The link lists are xconvert-web-ssr's `sources/site-nav.json` (commons/site-nav.ts, byte copy
 * site-nav.generated.json) - no link text or href is typed here (HANDOFF-L4 H5, 2026-10-11). Markup unchanged except the
 * `data-block` markers (link-hierarchy-20261026 METHOD §5.2): the columns are the policy's `footer` block (4 media columns of
 * FP-T1/T2 pages + the two app roots), the bottom row `footer-legal`; the HTML assertion counts anchors per marker, not per CSS class.
 */
export default class FooterV2Component extends Component<any, any> {
    constructor(props: {}) {
        super(props);
    }
    render() {
        return <footer className={styles.footer}>
            <div className={styles.container}>
                <nav className={styles.toolLinks} data-block="footer">
                    {FOOTER_COLUMNS.map(col => <div key={col.title} className={styles.toolColumn}>
                        <h4 className={styles.columnTitle}>{col.title}</h4>
                        {col.links.map(l => <a key={l.href} href={l.href}>{l.text}</a>)}
                    </div>)}
                </nav>
                <div className={styles.bottom}>
                    <div className={styles.copyright}>
                        &copy; {new Date().getFullYear()} XConvert.com. All Rights Reserved.
                    </div>
                    <nav className={styles.links} data-block="footer-legal">
                        {FOOTER_LEGAL_LINKS.map(l => <a key={l.href} href={l.href} className={styles.link}>{l.text}</a>)}
                    </nav>
                </div>
            </div>
        </footer>
    }
}
